import React from 'react'
import Table from './Table'
import general from '../../helpers/general'

import placeholderFood from '../../images/foodi-footer.png'
import IKImageWrapper from '../IKImageWrapper'
import styles from './Dishes.module.scss'

export default function Dishes({ Auth, data, updateDish, deleteDishes, clone }) {
	const columns = [
		{
			field: 'name',
			access: 'name',
		},
		{
			field: 'Price',
			render: function ({ row, column, index }) {
				if (row?.price && typeof row?.price === 'number') {
					return general.formatPrice(row?.price)
				}
				return null
			},
		},
		{
			field: 'Image',
			render: function ({ row }) {
				const imageSrc = row?.image || row?.restaurant?.logo

				return (
					<>
						{imageSrc ? (
							<IKImageWrapper
								transformation={[{ width: 80, height: 50 }]}
								loading="lazy"
								lqip={{ active: true }}
								image={imageSrc}
								alt={imageSrc}
							/>
						) : (
							<div className={styles.fallbackImage}>
								<img alt="" src={placeholderFood} />
							</div>
						)}
					</>
				)
			},
		},
		general?.checkPermissions({ exceptPermissions: ['dish'], originalPermissions: Auth?.user?.permissions }) && {
			field: 'Actions',
			render: ({ row }) => (
				<div className={`actionsWrapper`}>
					<>
						{!row?.fromParent && <i onClick={() => updateDish(row)} className={`edit-icon fal fa-edit`} />}
						<i onClick={() => clone(row)} className={`edit-icon fal fa-copy`} />
						{!row?.fromParent && (
							<i
								onClick={() => {
									if (row?._id) {
										deleteDishes([row?._id], row?.name)
										return
									}
									deleteDishes(row)
								}}
								className={`delete-icon far fa-trash-alt`}
							/>
						)}
					</>
				</div>
			),
		},
	]

	return (
		<Table
			columns={columns}
			rows={data || []}
			enableLocalPagination={true}
			enableSelectMultiple={true}
			onDeleteMultiple={(ids) => deleteDishes(ids)}
		/>
	)
}
